import React from 'react';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import saga_logo from 'src/assets/saga_logo.png';
import kivit_logo from 'src/assets/kivit_logo.png';
import orkestadoc_logo from 'src/assets/orkestadoc_logo.png';
import orkestamedia_logo from 'src/assets/orkestamedia_logo.png';
import saga_div_image from 'src/assets/saga_div_image.png';
import kivit_div_image from 'src/assets/kivit_div_image.png';
import orkestadoc_div_image from 'src/assets/orkestadoc_div_image.png';
import orkestamedia_div_image from 'src/assets/orkestamedia_div_image.png';
import useHeaderStore from 'src/store/useHeaderStore';
import { useModalStore } from 'src/store/useModalStore';


const SolutionsComponent: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const setSelectedOption = useHeaderStore((state) => state.setSelectedOption);
  const { openModalOrkestadoc } = useModalStore();

  const handleSocialClick = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <div className={classes.solutionsContainer}>
      <div className={classes.mainSolutions}>
        <h1 className={classes.solutionsTitle}>{t('SOLUTIONS_TITLE')}</h1>
        <p className={classes.solutionsDescription}>{t('SOLUTIONS_DESCRIPTION')}</p>

        
        <br /><br />
        {/* SAGA */}
        <div className={classes.newSection}>
          <div className={classes.contentContainer}>
            <img
              src={saga_logo}
              className={classes.titleImageOrkestaMedia}
              alt=''
            />
            <p className={classes.description}>{t('SAGA_DESCRIPTION')}</p>
            <p className={classes.description}>{t('SAGA_DESCRIPTION_2')}</p>
            <div className={classes.buttonContainer}>
              <button className={classes.buttonSecondary}
                onClick={() => {setSelectedOption('contact');}}
              >
                {t('QUOTE_NOW')}
              </button>
            </div>
          </div>
          <div className={classes.imageContainer}>
            <img
              src={saga_div_image}
              className={classes.largeImage}
              alt=''
            />
          </div>
        </div>
      </div>
      
      <div className={classes.secondSolutions}>
        {/* KIVIT */}
        <div className={classes.newSection}>
          <div className={classes.contentContainer}>
            <img
              src={kivit_div_image}
              className={classes.largeImage}
              alt=''
            />
          </div>
          <div className={classes.contentContainer}>
            <img
              src={kivit_logo}
              className={classes.titleImage}
              alt=''
            />
            <p className={classes.description}>{t('KIVIT_DESCRIPTION')}</p>
            <p className={classes.description}>{t('KIVIT_DESCRIPTION_2')}</p>
            <div className={classes.buttonContainer}>
            <button className={classes.buttonSecondary} 
                onClick={() => handleSocialClick('https://kivit.mx/')}
              >
                {t('QUOTE_NOW')}
              </button>
            </div>
          </div>
        </div>

        {/* ORKESTADOC */}
        <div className={classes.newSection}>
          <div className={classes.contentContainer}>
            <img
              src={orkestadoc_logo}
              className={classes.titleImageOrkestaMedia}
              alt=''
            />
            <p className={classes.description}>{t('ORKESTADOC_DESCRIPTION')}</p>

            {/* Bullet Points y Separadores Verticales */}
            <div className={classes.bulletPointsContainer}>
              <div className={classes.bulletPointGroup}>
                <div className={classes.bulletPoint}>
                  <span className={classes.bullet}>•</span> {t('ORKESTADOC_BULLET_POINT_1')}
                </div>
                <div className={classes.bulletPoint}>
                  <span className={classes.bullet}>•</span> {t('ORKESTADOC_BULLET_POINT_2')}
                </div>
                <div className={classes.bulletPoint}>
                  <span className={classes.bullet}>•</span> {t('ORKESTADOC_BULLET_POINT_3')}
                </div>
                <div className={classes.bulletPoint}>
                  <span className={classes.bullet}>•</span> {t('ORKESTADOC_BULLET_POINT_4')}
                </div>
                <div className={classes.bulletPoint}>
                  <span className={classes.bullet}>•</span> {t('ORKESTADOC_BULLET_POINT_5')}
                </div>
              </div>
            </div>

            <div className={classes.buttonContainer}>
              <button className={classes.buttonSecondary}
                onClick={() =>
                  openModalOrkestadoc()
                }
              >
                {t('SHOW_MORE')}
              </button>
            </div>
          </div>
          <div className={classes.imageContainer}>
            <img
              src={orkestadoc_div_image}
              className={classes.largeImage}
              alt=''
            />
          </div>
        </div>


        {/* ORKESTAMEDIA */}
        <div className={classes.newSection}>
          <div className={classes.imageContainer}>
            <img
              src={orkestamedia_div_image}
              className={classes.largeImage}
              alt=''
            />
          </div>
          <div className={classes.contentContainer}>
            <img
              src={orkestamedia_logo}
              className={classes.titleImageOrkestaMedia}
              alt=''
            />
            <p className={classes.description}>{t('ORKESTAMEDIA_DESCRIPTION')}</p>
            <p className={classes.description}>{t('ORKESTAMEDIA_DESCRIPTION_2')}</p>
            <div className={classes.buttonContainer}>
              <button className={classes.buttonSecondary} 
                onClick={() => handleSocialClick('https://orkestamed-ia.axeleratum.com/')}
              >
                {t('QUOTE_NOW')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionsComponent;
